import React, { useEffect, useState } from "react";
import FleetDisplay from "./helpers/FleetDisplay";
import Body from "./Body";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { VEHICLES as FALLBACK_VEHICLES } from "./helpers/Constants";
import { vehicleCodeChanger } from "./helpers/vehicleCodeChanger";

const GROUP_ORDER = [
  "O","A","B","C","C1","C2",
  "D","D1","D2","E","E1","E2",
  "EL","EL1","EL2","EL3",
  "F","F1","G",
  "H","H1","H2",
  "I","J","J1","J2",
  "K","L","LD","L1","L2",
  "M","M1","M2",
];

const sortByGroup = (list) =>
  [...list].sort((a, b) => {
    const ia = GROUP_ORDER.indexOf(vehicleCodeChanger(a.code));
    const ib = GROUP_ORDER.indexOf(vehicleCodeChanger(b.code));
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
  });

const FleetPage = () => {
  const { t } = useTranslation();
  const [vehicles, setVehicles] = useState(() => sortByGroup(FALLBACK_VEHICLES));
  const [width, setWidth] = useState(window.innerWidth);
  const [choosedCar, setChoosedCar] = useState({
    brand: null,
    code: null,
    picture: null,
    pictureSource: null,
  });
  const [reservationModalOpen, setReservationModalOpen] = useState(false);

  useEffect(() => {
    fetch(`https://api.whynotcarrental.com/api/fleet`)
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data) && data.length) setVehicles(sortByGroup(data));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onReserveClick = (car) => {
    setChoosedCar(car);
    setReservationModalOpen(true);
  };

  return (
    <>
      <Dialog
        open={reservationModalOpen}
        onClose={() => setReservationModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <IconButton
          onClick={() => setReservationModalOpen(false)}
          sx={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}
        >
          <CloseIcon />
        </IconButton>
        <Body
          choosedCar={choosedCar}
          setChoosedCar={setChoosedCar}
          isModal
        />
      </Dialog>

      <Box sx={{ pt: { xs: 5, md: 8 }, pb: 4, textAlign: "center" }}>
        <Typography variant="h4" fontWeight={700} color="#1C2541">
          {t("fleet")}
        </Typography>
      </Box>

      <FleetDisplay
        vehicles={vehicles}
        onReserveClick={onReserveClick}
        width={width}
        setQuoteMessage={() => {}}
      />
    </>
  );
};

export default FleetPage;
